module.exports = __webpack_public_path__ + "img/blank_group.fbd1ee9d.png";